/**
 * Cookie de ruteo de impresora (browser → WebSocket).
 * Por tenant: printerNumber_<tenant>. Migra el legacy printerNumber si existe.
 */

const LEGACY_COOKIE = 'printerNumber';

function getCookie(name) {
  const pattern = `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`;
  const match = document.cookie.match(new RegExp(pattern));
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value) {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/;`;
}

function clearCookie(name) {
  document.cookie = `${name}=; path=/; max-age=0`;
}

export function getTenantKey() {
  return (
    getCookie('tenant') ||
    (() => {
      try {
        return sessionStorage.getItem('tenant');
      } catch (_) {
        return null;
      }
    })() ||
    'unknown'
  );
}

export function getPrinterCookieName(tenant = getTenantKey()) {
  return `${LEGACY_COOKIE}_${tenant || 'unknown'}`;
}

export function getPrinterNumberCookie(tenant = getTenantKey()) {
  const scoped = getCookie(getPrinterCookieName(tenant));
  if (scoped) return scoped;

  // Migración one-shot del cookie global viejo
  const legacy = getCookie(LEGACY_COOKIE);
  if (legacy) {
    setCookie(getPrinterCookieName(tenant), legacy);
    clearCookie(LEGACY_COOKIE);
    return legacy;
  }
  return null;
}

export function setPrinterNumberCookie(value, tenant = getTenantKey()) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return;
  setCookie(getPrinterCookieName(tenant), trimmed);
  clearCookie(LEGACY_COOKIE);
}

export function clearPrinterNumberCookie(tenant = getTenantKey()) {
  clearCookie(getPrinterCookieName(tenant));
  clearCookie(LEGACY_COOKIE);
}
